import { useContext } from 'react';
import CountryContext from '../context/CountryProvider';

const useSelectedCountry = () => {
    return useContext(CountryContext);
}

export default useSelectedCountry;